import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse,HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { KeepAliveService } from './keep-alive.service';

@Injectable()
export class KeepAliveInterceptor implements HttpInterceptor {
  constructor(private keepAliveSerice: KeepAliveService) {
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse && event.status == 401) {
        this.keepAliveSerice.stop(); //Stop service if we get unauthorized back
      }
      if (event instanceof HttpResponse && event.status == 200) {
        if(event.url.indexOf('ibm_security_logout')> 0)
          this.keepAliveSerice.stop();
        else
          this.keepAliveSerice.recordSucess();
      }
    }, (err: any) => {}));
  }
}